import "core-js/modules/es.array.push.js";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import { useMainStore } from "../pinia/main";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive, computed, watch, h } from "vue";
import { city } from "../util/city";
import moment from "moment";
import { isPhoneNumber, phoneDesc, EncryptName } from "../util/index";
import { ElMessage, ElMessageBox } from "element-plus";
import clipboard3 from "vue-clipboard3";
import DynamicInput from "@/components/invoice/dynamicInput.vue";
import { freightUnitTypeMap, orderStatusList, invoiceSuccessList } from "@/util/type";

import { ElAlert } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/alert/style/css';
export default {
  name: "Order",
  setup() {
    const {
      toClipboard
    } = clipboard3();
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      tabs: [{
        label: "全部",
        value: -1
      }, {
        label: "待装货",
        value: 1
      }, {
        label: "运输中",
        value: 2
      }, {
        label: "已完成",
        value: 3
      }, {
        label: "待评价",
        value: 4
      }],
      times: "",
      tabsIndex: -1,
      beginTime: "",
      demandNo: "",
      driverName: "",
      driverPhone: "",
      endTime: "",
      loadingAddress: "",
      orderNo: "",
      unloadingAddress: "",
      page: 1,
      //当前页数
      size: 10,
      //一页几条
      total: 0,
      //共几条
      pages: 0,
      //一共几页
      list: [],
      cascaderProps: {
        label: "value"
      },
      unloadingCity: "",
      loadingCity: ""
    });
    const dialog = reactive({
      visible: false,
      contractInfo: "",
      orderId: 0,
      type: 1
    });
    onMounted(() => {
      data.tabsIndex = Number(route.query.type || -1);
      webOrderList();
    });
    const webOrderList = async () => {
      const params = {
        beginTime: data.times[0] ? moment(data.times[0]).format("YYYY-MM-DD") : "",
        demandNo: data.demandNo,
        driverName: data.driverName,
        driverPhone: data.driverPhone,
        endTime: data.times[1] ? moment(data.times[1]).format("YYYY-MM-DD") : "",
        loadingAddress: data.loadingAddress[1] ?? "",
        orderNo: data.orderNo,
        unloadingAddress: data.unloadingAddress[1] ?? "",
        status: data.tabsIndex,
        page: data.page,
        size: data.size
      };
      const res = await globalProperties.$api.webOrderList(params);
      data.page = res.current;
      data.total = res.total;
      data.size = res.size;
      data.list = res.records;
    };

    //重置
    const reset = () => {
      data.page = 1;
      data.times = "";
      data.beginTime = "";
      data.demandNo = "";
      data.driverName = "";
      data.driverPhone = "";
      data.endTime = "";
      data.loadingAddress = "";
      data.orderNo = "";
      data.unloadingAddress = "";
      webOrderList();
    };
    // 分页搜索
    const currentChange = page => {
      data.page = page;
      webOrderList();
    };
    //查询
    const search = () => {
      data.page = 1;
      webOrderList();
    };
    //联系司机
    const contact = phone => {
      ElMessageBox.confirm("点击复制承运人号码", {
        confirmButtonText: "复制号码",
        cancelButtonText: "取消",
        type: "primary"
      }).then(() => {
        toClipboard(phone);
        ElMessage({
          type: "success",
          message: "已复制"
        });
      }).catch(() => {});
    };

    //取消订单
    const cancelOrder = async orderId => {
      await globalProperties.$api.applyForCancelOrder(orderId);
      ElMessage.success("申请成功，待承运人同意");
      webOrderList();
    };

    //获取签约协议并展示弹窗
    const sign = async record => {
      const {
        orderId
      } = record;
      const {
        isSigned,
        type
      } = await globalProperties.$api.selectContractType(orderId);
      //需要签署的类型1->订单撮合合同 2->长期协议合同
      if (isSigned) {
        return ElMessage.success("您已签约，待承运人完成签约");
      }
      const contractInfo = type == 1 ? await globalProperties.$api.generate(orderId) : await globalProperties.$api.longTimeContract(orderId);
      dialog.contractInfo = contractInfo;
      dialog.orderId = orderId;
      dialog.type = type;
      dialog.visible = true;
    };

    //签约
    const handleContractSign = () => {
      ElMessageBox.confirm("已阅读合同内容并签约？", {
        confirmButtonText: "已读并签约",
        cancelButtonText: "再想想",
        type: "info"
      }).then(async () => {
        dialog.type == 1 ? await globalProperties.$api.contractSign(dialog.contractInfo.contractId) : await globalProperties.$api.signLongTimeContract({
          contractId: dialog.contractInfo.contractId,
          orderId: dialog.orderId
        });
        dialog.visible = false;
        ElMessage.success("签约成功");
        webOrderList();
      }).catch(() => {});
    };

    //确认结算
    const invoice = async record => {
      ElMessageBox.alert("承诺您所发布的运输业务真实有效。业务完成后及时向承运人索取合法有效的发票，并结清费用。如有疑问请联系客服", "提示", {
        confirmButtonText: "我已知悉",
        callback: async action => {
          if (action == "cancel") return;
          const res = await globalProperties.$api.calculateOrderInfo([{
            amount: record.driverAmount,
            orderId: record.orderId
          }]);
          let editAmount = res[0].invoiceAmount / 100;
          ElMessageBox.confirm("", "", {
            title: "确认信息",
            message: h("div", [h(ElAlert, {
              title: "注意：需承运人提供合法发票后在进行结算！",
              type: "warning",
              closable: false
            }), h("p", `　`), h("p", `企业抬头：${res[0].name}`), h("p", `企业税号：${res[0].taxNo}`), h("p", `应税发生地：${res[0].invoiceAddress}`), h("p", `电子邮箱：${res[0].email}`), h(DynamicInput, {
              initialValue: res[0].invoiceAmount / 100,
              onConfirm: value => {
                editAmount = value;
              }
            })]),
            confirmButtonText: "确定结算",
            // inputPlaceholder: "请输入最终费用（含税）",
            cancelButtonText: "取消"
            // inputValue: res[0].invoiceAmount / 100,
            // inputPattern: /^\d+(\.\d{1,2})?$/,
            // inputErrorMessage: "价格格式有误",
          }).then(async () => {
            const params = {
              list: [{
                amount: Math.floor(Number(editAmount) * 100 * 100) / 100,
                orderId: record.orderId
              }]
            };
            var res = await globalProperties.$api.applyInvoice(params);
            if (res) {
              webOrderList();
              ElMessage.success("申请已提交");
            }
          }).catch(() => {});
        }
      }).catch(() => {});
    };

    //查看订单详情
    const toOrderDeatil = orderId => {
      router.push({
        path: "/layout/orderdetail",
        query: {
          orderId
        }
      });
    };

    //去评价
    const toEvaluate = record => {
      const {
        driverId,
        orderId
      } = record;
      router.push({
        path: "/layout/evaluatedetail",
        query: {
          orderId,
          receiveUserId: driverId
        }
      });
    };

    //查看简介
    const viewProfile = customerId => {
      router.push({
        path: "/layout/personalprofile",
        query: {
          customerId
        }
      });
    };
    //托运人-承运人-同意取消订单
    const agreeCancelOrder = async (orderId, status) => {
      await globalProperties.$api.agreeCancelOrder({
        orderId,
        status
      });
      ElMessage.success("操作成功");
      webOrderList();
    };
    const setTabsIndex = tabsIndex => {
      data.tabsIndex = tabsIndex;
      search();
    };
    return {
      agreeCancelOrder,
      viewProfile,
      toEvaluate,
      toOrderDeatil,
      invoice,
      handleContractSign,
      sign,
      contact,
      freightUnitTypeMap,
      orderStatusList,
      invoiceSuccessList,
      dialog,
      zhCn,
      mainStore,
      data,
      city,
      search,
      reset,
      currentChange,
      moment,
      isPhoneNumber,
      phoneDesc,
      EncryptName,
      setTabsIndex
    };
  }
};